import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { usePentagovContext } from "../../context/pentagovContext";
import { useAuthContext } from "../../context/authContext";
import { useOperador } from "../../Hooks/useOperador";
import { usePermissao } from "../../Hooks/usePermissao";
import { ETipoPermissao } from "../../Enum/Enum";
import UploaderArquivos from '../FileUploader';
import Swal from "sweetalert2";
import { IoReturnDownBackOutline } from "react-icons/io5";
import { RiFolderAddFill } from "react-icons/ri";
import { AiFillFileAdd } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./stylepasta.css";
import api from "../../Services/api";

const MenuPastas = ({ onClickBotaoVoltar, carregarConteudo, IDProcesso, IDPastaPai }) => {
  const [exibirUploader, setExibirUploader] = useState(false);
  const [exibirModal, setExibirModal] = useState(false);
  const [atualizarArquivos, setAtualizarArquivos] = useState(false);
  const [nomeNovaPasta, setNomeNovaPasta] = useState("");
  const { objPastaAberta, bucketAberto } = usePentagovContext();
  const { nome, IDOperador, permissaoPrincipal, cargos } = useOperador();
  const { permissoes } = usePermissao();
  const navigate = useNavigate();

  useEffect(() => {
    carregarConteudo(IDPastaPai, IDProcesso);
    return;
  }, [atualizarArquivos]);

  const novoArquivo = () => {
    if (!objPastaAberta) {
      Swal.fire({
        icon: "warning",
        title: "Nenhuma pasta selecionada",
        text: "Selecione uma pasta para adicionar um novo arquivo.",
        confirmButtonText: "OK",
        width: 'auto',
        toast: true,
      });
      return;
    }
    setExibirUploader(!exibirUploader);
  };

  const criarNovaPasta = async () => {
    try {
      if (!nomeNovaPasta.trim()) {
        Swal.fire("Aviso", "O nome da pasta não pode estar vazio.", "warning");
        return;
      }

      console.log(objPastaAberta);
      console.log(IDProcesso);
      console.log(IDPastaPai);

      await api.post("/diretorio", {
        IDProcesso: IDProcesso,
        IDCriador: IDOperador,
        descricao: nomeNovaPasta.trim(),
        descricaoExibicao: nomeNovaPasta.trim(),
        IDPai: IDPastaPai,
        IDFilho: null,
        nomeBucketAws: bucketAberto, //'pentagov-dev',
        tipo: "1",
        situacao: 1,
      });

      Swal.fire("Sucesso", "Pasta criada com sucesso!", "success");
      setExibirModal(false);
      setNomeNovaPasta("");

      await carregarConteudo(IDPastaPai, IDProcesso);
    } catch (err) {
      console.error("Erro ao criar pasta:", err);
      Swal.fire("Erro", "Não foi possível criar a nova pasta.", "error");
    }
  };

  function AbrirTelaEstrutura() {
    navigate(`/UploadEstrutura/${IDProcesso}/${IDPastaPai}/${bucketAberto}`);
  }

  const handleVoltar = () => {
    setExibirUploader(false);
    onClickBotaoVoltar();
  };

  return (
    <div>
      <div className="menu-pastas-container">
        {/**fixei o cargo 12, provisorio */}
        <div className="botoes-centrais" >
          <div className="botao-voltar">
            <button className="btn btn-secondary btnBotaoVoltar" onClick={handleVoltar}>
              <IoReturnDownBackOutline style={{ fontSize: 20, paddingRight: '5px' }} />
              Voltar
            </button>
          </div>
          {permissoes?.some(p => p.tipo !== ETipoPermissao.LEITURA) && cargos[0]?.IDCargo !== 12 && (
            <div>
              <button className="btn btn-primary me-3 mt-3" onClick={() => setExibirModal(true)}>
                <RiFolderAddFill style={{ marginRight: '5px', fontSize: 18, verticalAlign: 'text-bottom' }} />
                Nova Pasta
              </button>
              {objPastaAberta && (
                <button className="btn btn-primary me-3 mt-3" onClick={novoArquivo}>
                  <AiFillFileAdd style={{ marginRight: '5px', fontSize: 18, verticalAlign: 'text-bottom' }} />
                  Novo arquivo
                </button>
              )}
              <button className="btn btn-primary me-3 mt-3" onClick={AbrirTelaEstrutura}>
                <RiFolderAddFill style={{ marginRight: '5px', fontSize: 18, verticalAlign: 'text-bottom' }} />
                Estrutura Pastas
              </button>
            </div>
          )}
        </div>

      </div>

      {objPastaAberta && exibirUploader && (
        <UploaderArquivos
          tipoPermissao={permissaoPrincipal}
          bucketName={bucketAberto}
          IDDiretorio={objPastaAberta.IDDiretorio}
          setExibirUploader={() => setExibirUploader(!exibirUploader)}
          setAtualizarArquivos={() => setAtualizarArquivos(!atualizarArquivos)}
          permitirDocs={true}
        />
      )}

      {/* Modal Nova Pasta */}
      <Modal show={exibirModal} onHide={() => setExibirModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Criar Nova Pasta</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="nomePasta">
              <Form.Label>Nome da nova pasta</Form.Label>
              <Form.Control
                type="text"
                placeholder="Digite o nome"
                value={nomeNovaPasta}
                onChange={(e) => setNomeNovaPasta(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" className="btn-cancel-danger btn-modal-action" onClick={() => setExibirModal(false)}>
            Cancelar
          </Button>
          <Button variant="primary" className="btn-modal-action" onClick={criarNovaPasta}>
            Criar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default MenuPastas;
